import { AppBox } from './boxes/AppBox';
import { handleTranslation } from '../lib/util/helpers';

export function AppImage({ alt = '', as, ...rest }) {
  return <AppBox {...rest} as='img' alt={handleTranslation(alt)} />;
}
